module.exports = __webpack_public_path__ + "static/images/tag-bg-95.171fff3.png";